import { Periodicity } from '@/modules/Tasks/types/periodicity';
import { useTranslation } from 'react-i18next';

type PeriodicityColumnProps = {
  periodicity: Periodicity;
};

export const PeriodicityColumn = ({ periodicity }: PeriodicityColumnProps) => {
  const { t } = useTranslation();
  return (
    <div className="w-full overflow-hidden text-ellipsis text-nowrap">
      {t(`periodicity_types.${Periodicity[periodicity]}`)}
    </div>
  );
};
